import { get } from "lodash";
import { useMemo, useState } from "react";
import { MdArrowDropDown } from "react-icons/md";
import { useMediaQuery } from "react-responsive";
import UserRed from "shared/components/SVG/LMF/UserRed";
import { CURRENCY_SYMBOL } from "utils/constants";
import { capitalizeWords } from "utils/helpers/style";
import { costToFrench } from "utils/helpers/values";
import icon from "../svg/money-icon.svg";
import Cart from "./Cart";
import Profile from "./Profile";

const View = ({
  generalCost,
  subscription,
  modules = [],
  onEdit,
  onRelatedPersonEdit,
  onProfileEdit,
  contact,
  loading,
}) => {
  const [open, setOpen] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const totalAmount = useMemo(() => {
    return modules
      .reduce((acc, { cost }) => (acc += cost), get(generalCost, "cost", 0))
      .toFixed(2);
  }, [modules, generalCost]);

  const contactName = useMemo(() => {
    return capitalizeWords(
      get(contact, "user.firstname") + " " + get(contact, "user.lastname"),
    );
  }, [contact]);

  return (
    <>
      <Profile
        open={openProfile}
        setOpen={setOpenProfile}
        onEdit={onProfileEdit}
        onRelatedPersonEdit={onRelatedPersonEdit}
        contact={contact}
      />
      <Cart
        open={open}
        setOpen={setOpen}
        generalCost={generalCost}
        subscription={subscription}
        onEdit={onEdit}
        modules={modules}
      />

      {contact &&
        (isMobile ? (
          <UserRed
            size={isMobile ? 24 : 40}
            onClick={() => setOpenProfile(true)}
            className="profile--icon"
          />
        ) : (
          <div className="profile--card" onClick={() => setOpenProfile(true)}>
            <span>{contactName}</span>
            <MdArrowDropDown size={20} />
          </div>
        ))}

      <div onClick={() => setOpen(true)} className="cart-button">
        <img src={icon} alt="" />
        <div className="amount">
          {loading || !Number(totalAmount) ? <></> : costToFrench(totalAmount)}
        </div>
        <div className="currency">
          {CURRENCY_SYMBOL.EUR}
          <small> /mois</small>
        </div>
      </div>
    </>
  );
};

export default View;
